import React, { useState, useEffect } from 'react';
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Paper,
  Typography,
  Button,
  Box,
  MenuItem,
  Chip,
} from '@mui/material';
import { DownloadOutlined, Search, Block, CheckCircle, VerifiedUser } from '@mui/icons-material';
// import { serverUrl } from '../server';
import { getRequest, patchRequest, server } from '../config';
import moment from 'moment';
import axios from 'axios';
import { toast } from 'react-toastify';

const CustomerList = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [customers, setCustomers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filterType, setFilterType] = useState("all"); 
  const [actualLength, setactualLength] = useState(0)
  const [actualCustomers, setactualCustomers] = useState([])
  const [updatingCustomerId, setUpdatingCustomerId] = useState(null);
  const durationOptions = [
    { label: "All Customers", value: "all" },
    { label: "Old Customers", value: "old" },
   
  ];
 
  
  useEffect(() => {
    fetchCustomers();
  }, [searchQuery, page, rowsPerPage,filterType]);
  const handleExport = async () => {
    try {
      const filter = {
        where: {
          or: [
            { name: { like: searchQuery } },
            { mobileNumber: { like: searchQuery } },
          ],
          userType: "customer",
          ...(filterType === "old" ? { referralCode: null, location: null } : {}),
        },
        order: "createdAt desc",
      };
      const endpoint = `${server.uri}users/export?filter=${encodeURIComponent(
        JSON.stringify(filter)
      )}`;
      const response = await axios.get(endpoint, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

      // Create a blob link to download
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", 'customerList.csv'); // Set filename for download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting CSV:", error);
      alert("Failed to export data.");
    }
  };
  // Fetch customers from the LoopBack backend with filter and pagination
  const fetchCustomers = async () => {
    try {
      if(filterType=='old'){
        const response = await getRequest(
          `${server.uri}users?filter={
          "where":{
          "or":[
          {"name":{"like":"${searchQuery}"}},
          {"mobileNumber":{"like":"${searchQuery}"}}
        ],"userType":"customer"},
          "order":"createdAt desc"}`
        );
        const filter=response?.filter((item)=>!item?.referralCode&&!item?.location)
        setCustomers(filter);
       
        setTotalCount(filter?.length)
        return
      }
      const filter = {
        where: {
          or: [
            { name: { like: `%${searchQuery}%` } },
            { email: { like: `%${searchQuery}%` } },
            { phone: { like: `%${searchQuery}%` } },
          ],
        },
        skip: page * rowsPerPage,
        limit: rowsPerPage,
      };

      const response = await getRequest(
        `${server.uri}users?filter={
        "where":{
        "or":[
        {"name":{"like":"${searchQuery}"}},
        {"mobileNumber":{"like":"${searchQuery}"}}
      ],"userType":"customer"},"skip":"${filter.skip}",
        "limit":"${filter.limit}","order":"createdAt desc"}`
      );
    //   console.log(response);
      
      setCustomers(response);
      setactualCustomers(response)
      const responseCount = await getRequest(
        `${server.uri}users/count?where={
        
        "or":[
        {"name":{"like":"${searchQuery}"}},
        {"mobileNumber":{"like":"${searchQuery}"}}
      ],"userType":"customer"}`
      );
      // Fetch total count for pagination
    //   const countResponse = await fetch(
    //     `/api/customers/count?where[or][0][name][like]=%25${searchQuery}%25&where[or][1][email][like]=%25${searchQuery}%25&where[or][2][phone][like]=%25${searchQuery}%25`
    //   );
    //   const countData = await countResponse.json();
    console.log(responseCount);
    setactualLength(responseCount.count)
      setTotalCount(responseCount.count);
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };

  // Handle search query change
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setPage(0); // Reset to the first page when search changes
  };

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page when rows per page changes
  };
  const handleToggleCustomerVerification = async (customer) => {
    const nextStatus = customer?.status === 'verified' ? 'unverified' : 'verified';
    setUpdatingCustomerId(customer.userId);
    try {
      const response = await patchRequest(`${server.uri}users/${customer.userId}`, {
        status: nextStatus,
      });
      if (response === 200) {
        toast.success(`Customer marked ${nextStatus}`);
        fetchCustomers();
      } else {
        toast.error(`Failed to update customer status`);
      }
    } catch (error) {
      console.error('Update Customer Status Error:', error);
      toast.error('Failed to update customer status. Please try again.');
    } finally {
      setUpdatingCustomerId(null);
    }
  };
const handleDeletePartner = async (userId) => {   
    if (!window.confirm("Are you sure you want to delete this customer?")) {
      return;
    }
    try {
     const res= await patchRequest(`${server.uri}/users/${userId}`, {
        isDeleted:true
      });
      if(res!==200){  
       toast.error("Failed to delete customer");
       return
      }
      toast.success("Partner deleted successfully");
   
    } catch (err) {
      console.error(err);
      alert("Failed to delete partner");
    }
  }
  return (
    <Container>
      <div style={{marginTop: '50px', marginBottom: '20px' }} className='flex items-center justify-between'>
      <Typography variant="h4" >
        Customer List
      </Typography>
      <Button onClick={handleExport} variant='contained'><DownloadOutlined/> Export To CSV</Button>
      </div>

      {/* Search Bar */}
      <div className='flex flex-row items-center gap-3'>
      <TextField
        variant="outlined"
        placeholder="Search by name, email, or phone"
        fullWidth
        value={searchQuery}
        onChange={handleSearch}
        InputProps={{
          startAdornment: (
            <Search sx={{ color: 'gray', marginRight: 1 }} />
          ),
        }}
       
      />
           <Box
          sx={{ display: "flex", alignItems: "center", gap: 2, marginRight: 2 }}
        >
          <TextField
            select
            label="Filter by Type"
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            fullWidth
          >
            {durationOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          {/* Specific Date Input (Visible only for "Specific Date" filter) */}
          
        </Box>
        </div>
 <Typography variant="subtitle1" sx={{textAlign:'right'}} gutterBottom>
        Total Customers: <strong>{totalCount}</strong>
      </Typography>
      {/* Customer Table */}
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow  sx={{
                  backgroundColor: '#f4f6f8', // Light background for table header
                }}>
               
                <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
              
                <TableCell sx={{ fontWeight: 'bold' }}>Phone</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Joined At</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Account</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customers.map((customer) => (
                <TableRow  sx={{
                    '&:nth-of-type(even)': {
                      backgroundColor: '#f9fafb', // Alternate row color for better readability
                    },
                  }} key={customer.id}>
                  
                  <TableCell>{customer?.name}</TableCell>
                  
                  <TableCell>{customer?.mobileNumber}</TableCell>
                  <TableCell>{customer?.status}</TableCell>
                  <TableCell>{moment(customer?.createdAt).startOf('hour').fromNow()}</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>{(customer?.referralCode)&&'new'}</TableCell>
                  <TableCell>
                    {customer?.status === 'verified' ? (
                      <Chip label="Verified" color="success" size="small" icon={<CheckCircle />} />
                    ) : (
                      <Chip label="Unverified" color="warning" size="small" icon={<Block />} />
                    )}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>
                    <Button
                      color={customer?.status === 'verified' ? 'warning' : 'success'}
                      variant="outlined"
                      type="button"
                      disabled={updatingCustomerId === customer?.userId}
                      startIcon={customer?.status === 'verified' ? <Block /> : <VerifiedUser />}
                      onClick={() => handleToggleCustomerVerification(customer)}
                    >
                      {customer?.status === 'verified' ? 'Mark Unverified' : 'Verify'}
                    </Button>
                    <Button sx={{ ml: 1 }} color="error" variant='contained' type='button' onClick={()=>handleDeletePartner(customer?.userId)}>
                      Delete User
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25,50,100,200,500,1000,2000,100000]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Container>
  );
};

export default CustomerList;
